import { LOCALES } from "../locales";

export default {
  [LOCALES.SPANISHLATIN]: {
    // general product translation
    January: "enero",
    February: "febrero",
    March: "marzo",
    April: "abril",
    May: "mayo",
    June: "junio",
    July: "julio",
    August: "agosto",
    September: "setiembre",
    October: "octubre",
    November: "noviembre",
    December: "diciembre",

    class_policy: "Condiciones de las clases",
    Faq: "FAQs",
    help: "Ayuda",
    frequently_asked_ques: "Preguntas frecuentes",
    customer_support: "Atención al cliente",
    user_name: "Nombre de usuario",
    password: "Contraseña",
    email_address: "Dirección de correo electrónico",
    // Header Translations
    notification: "Notificación",
    page_loading_aria: "La página se está cargando",
    state_loading_aria: "Cargando estado",
    city_loading_aria: "Cargando ciudad",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Insignia general",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Imagen del certificado",
    certificate_download: "Botón de descarga del certificado",
    prev: "Anterior",
    log_out: "Cerrar sesión",
    // feature names
    feature_progress: "Progreso",
    feature_stressAndIntonation_title: "Acentuación y entonación",
    feature_soundOfEnglish_title: "Sonidos del inglés",
    feature_vocabularyCenter_title: "Centro de vocabulario",
    feature_grammarCenter_title: "Centro de gramática",
    feature_cultureNotes_title: "Información cultural",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Catálogo de artículos",
    feature_newsfeed_title: "Noticias",
    feature_emailTemplates_title: "Plantillas de email",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Acentos y dialectos",
    feature_writingCenter_title: "Centro de redacción",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Sobre",
    legal: "Legal",
    privacy_policy: "Política de privacidad",
    Terms_conditions: "Términos y condiciones",
    //button translations
    button_continue: "Continuar",
    button_KnowMore: "Saber más",
    button_BuyNow: "Comprar",
    button_Subscribe: "Suscríbete",
    button_GetStarted: "Comenzar",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "Ver detalles",
    button_ContinueStudying: "Continuar",
    button_next: "Siguiente",
    button_confirm: "Confirmar",
    // cookie policy
    common_cookiesPolicyText1:
      "Al continuar usando este sitio web aceptas el uso de cookies para proporcionarte mejores servicios. Saber más sobre nuestra",
    common_cookiesPolicyText2: "política de cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "¡Te damos la bienvenida,",
    login_heloo: "Hola de nuevo",
    login_welcome_text: "Comencemos",
    login_log_in: "Iniciar sesión",
    login_errorIncorrectCreds: "Nombre de usuario o contraseña incorrectos",
    login_errorContactAmin: "Tu cuenta no está activada. Por favor, contacta con tu administrador",
    login_errorSSOuser: "Debes iniciar sesión desde el portal de aprendizaje de tu empresa.",
    login_forgotPassword: "¿Olvidaste tu contraseña?",
    login_resetPasswordTitle: "Restaurar contraseña",
    login_resetSuccess: "Te eviamos un email con un enlace en el que podrás restablecer tu contraseña.",
    login_resetFailure: "La dirección de correo electrónico es incorrecta",
    // common translations
    message_errorDefault: "Algo salió mal",
    message_successUpdated: "Se actualizó correctamente",
    message_unknownError: "Unknown error",
    message_unAuthorized: "No tienes permiso",
    message_passwordUpdated: "Contraseña actualizada correctamente",
    message_profileUpdated: "Perfil actualizado correctamente",
    message_welcomeSubmitted: "Enviado correctamente",
    message_samepasswordError: "Escribe una nueva contraseña, asegúrate de no haberla usado previamente.",
    SAR: "Selecciona una zona",
    SAL: "Selecciona una ubicación",
    SAT: "Selecciona un tema",
    link_readmore: "Leer más",
    //--//
    profile_title: "Perfil",
    profile_nameLabel: "Mi nombre es: ",
    profile_countryLabel: "País",
    profile_stateLabel: "Estado / Provincia / Región",
    profile_cityLabel: "Ciudad",
    profile_emailLabel: "Correo electrónico",
    profile_prefContactLabel: "Método de contacto preferido",
    profile_prefSkypeLabel: "Skype (Personal) ID",
    profile_prefMobileLabel: "Número de celular",
    profile_prefLandlineLabel: "Número fijo",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Acepto los términos y condiciones",
    profile_continueAria: "Botón Continuar",
    profile_TermsAria: "Aceptar términos y condiciones",
    profile_stateTooltip: "Su zona horaria nos ayudará a programar sus sesiones en vivo.",
    profile_cityTooltip: "Si no vive en ninguna de las ciudades que aquí aparecen, seleccione la más cercana.",
    profile_emailTooltip: "Verifica tu correo electrónico",
    profile_prefTooltip:
      "Todas las sesiones tendrán lugar en el Aula Virtual, incluso si ha seleccionado un método de contacto diferente en el proceso de incorporación. El método preferido de contacto es solo para uso interno, así podemos mejorar continuamente su experiencia educativa.",
    profile_fnamePlaceholder: "Nombre",
    profile_lnamePlaceholder: "Apellidos",
    profile_countryPlaceholder: "Selecciona un país",
    profile_prefContactSelect: "Selecciona tu preferencia",
    profile_statePlaceholder: "Selecciona un estado",
    profile_cityPlaceholder: "Seleccionar una ciudad",
    profile_emailInvalidMessage: "La dirección de correo electrónico es incorrecta",
    profile_prefContactPlaceholder: "Elige tu preferencia",
    profile_prefSkypePlaceholder: "Skype (Personal)",
    profile_emailVerifiedChip: "Verificado",
    profile_emailVerifyChip: "Verificar",
    profile_emailpopup_head: "Introduce el código de verificación",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Reenviar código",
    profile_emailpopup_resendMessage: "¿No has recibido ningún código?",
    profile_invalidNumber: "Número invalido",
    profile_prefSkypeAria: "Modo de contacto preferido, Skype ID (Personal)",
    profile_prefMobileAria: "Modo de contacto preferido, celular",
    profile_prefLandlineAria: "Modo de contacto preferido, teléfono fijo",
    profile_emailpopup_incorrectCode: "Código no válido",
    profile_editLabel: "Editar perfil",
    profile_editAria: "Editar",
    profile_mainPasswordPlaceholder: "Introducir contraseña aquí",
    profile_updateLabel: "Actualizar",
    profile_welcomeJumbotron: "Háblamos de ti",
    profile_cancelLabel: "Cancelar",
    noAccessl1: "¡Ups! No tienes los permisos para ver esta página.",
    noAccessl2: "Aquí tienes un enlace para volver",
    noAccessl2_1: "a la página de inicio",
    noAccessl3: "Contacta con el Administrador para obtener ayuda.",
    profile_changepass_changepassHead: "Cambiar contraseña",
    profile_changepass_currentpassword: "Contraseña actual",
    profile_changepass_currentpasswordPlaceholder: "Introducir contraseña actual",
    profile_changepass_newpassword: "Nueva contraseña",
    profile_changepass_newpasswordPlaceholder: "Introducir nueva contraseña",
    profile_changepass_confirmnewpassword: "Confirmar nueva contraseña",
    profile_changepass_confirmnewpasswordPlaceholder: "Confirmar nueva contraseña",
    profile_passMustInclude: "Tu contraseña debe incluir:",
    profile_passdontmatch: "Las contraseñas no coinciden",
    profile_incorrectPassword: "Contraseña incorrecta",
    profile_passwordSubmit_title: "Introducir contraseña",
    profile_changepass_conditionLength: "Debe contener entre 8 y 32 caracteres",
    profile_changepass_conditionUppercase: "Al menos una letra mayúscula",
    profile_changepass_conditionLowercase: "Al menos una letra minúscula",
    profile_changepass_conditionSpecialCharacters: "Al menos un dígito o uno de estos símbolos $!#&@?%*_",
    profile_translationLanguage: "Preferencia de idioma",
    profile_translationLanguagePlaceholder: "Selecciona un idioma",
    profile_managerEmailPlaceholder: "Correo electrónico del manager",
    profile_managerEmailpopupPlaceholder: "Dirección de correo electrónico del manager",
    // Learner Home Page translations
    learnerhome_survey_header: "Feedback",
    learnerhome_survey_line1: "Tu compañía quiere conocer tu experiencia usando nuestros servicios.",
    learnerhome_survey_line2: "Completa la encuesta antes del",
    learnerhome_survey_line3: "Tu opinión es muy importante para nosotros.",
    learnerhome_survey_button1: "Hacer encuesta",
    learnerhome_survey_button2: "Saltar encuesta",
    active_course: "Curso",
    admin_header: "Administration",
    get_startedText: "Pulsa en un curso para comenzar.",
    product_solo_desc:
      "Learnship Solo, nuestro servicio de e-learning, ofrece todo lo que necesitas para practicar y mejorar tus habilidades a tu propio ritmo.",
    product_conversationPractice_desc:
      "Podrás reservar sesiones uno-a-uno con profesores para hacer preguntas, hablar de problemas particulares o practicar la conversación con ejemplos de situaciones reales. Útil si tienes un nivel más avanzado y buscas mejorar sus habilidades.",
    product_sprint_businessSkills_desc:
      "Este programa de aprendizaje blended de nueva generación te ayudará a desarrollar habilidades de negocios específicas, presentaciones, negociaciones, redacción de negocios y participación en reuniones, en tiempo récord. ",
    product_sprint_levelsProgress_desc:
      "Gracias a nuestro método de aprendizaje blended de nueva generación mejorarás tus habilidades en un idioma extranjero dentro de un marco estandarizado de manera rápida.",
    product_evolve_relocationLanguage_desc:
      "Con nuestro programa de reubicación de empleados podrás desarrollar una mayor comprensión del idioma y los aspectos sociales de tu nuevo país de residencia.",
    product_evolve_culturePowerSkills_desc:
      "Habilidades interculturales esenciales para prosperar en entornos de trabajo internacionales y equipos globales virtuales.",
    product_evolve_cultureFocus_desc:
      "Ofrecemos también capacitación específica centrada en el país e inteligencia cultural que te ayudará a comprender mejor la cultura de trabajo de tu nuevo país de destino.",
    product_evolve_cultureChange_desc:
      "Nuestro programa principal de capacitación para empresas en comunicación intercultural para empleados expatriados. Te proporcionará una visión completa de lo que significa vivir y trabajar en una nueva cultura.",
    product_elevate_businessSkills_desc:
      "Módulos de capacitación cortos y estandarizados para mejorar habilidades específicas como presentaciones en público, negociaciones o liderazgo de equipo. Si lo que quieres es centrarte en la terminología específica de la industria, también ofrecemos cursos para especialistas.",
    product_elevate_levelsProgress_desc:
      "Este curso de idiomas para empresas dirigido por profesor te ayudará a mejorar tus habilidades escritas y orales dentro de un marco estandarizado.",
    product_coach_languageCoach_desc:
      "Comunícate de manera clara y segura en salas de conferencias, emails, negociaciones e incluso alrededor de la fuente de agua. El coaching individual y específico para ejecutivos en idiomas te ayuda a dominar los escenarios de negocios más importantes. Desarrolla tus habilidades de comunicación verbales, escritas, de reunión y personales.",
    product_coach_cultureCoach_desc:
      "Programa de coaching uno-a-uno, para ejecutivos que buscan solucionar problemas específicos de comunicación intercultural.",
    product_solo_business_english:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german:
      "Un programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del alemán de negocios a tu propio ritmo.",
    product_solo_business_french:
      "Un programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del francés de negocios a tu propio ritmo.",
    product_solo_business_spanish:
      "Un programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del español de negocios a tu propio ritmo.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Esta es tu puerta de entrada a Dashboard, una interfaz intuitiva que permite a los administradores hacer un seguimiento del uso, analizar el progreso de los alumnos, optimizar los programas y evaluar el ROI.",
    product_elevate_desc: "Elevate Business English es nuestro programa de capacitación online uno-a-uno para estudiantes corporativos que quieren mejorar su nivel general de inglés con un profesor particular.",
    product_lorem_solo_desc:
      "Este programa multimedia ayuda a tus empleados a mejorar rápidamente sus habilidades lingüísticas en inglés dentro de un marco estandarizado.",
    //feature translations
    feature_cultureNotes_desc:
      "Familiarízate con las culturas de las regiones relevantes para tus negocios y vida profesional.",
    feature_emailTemplates_desc:
      "Las plantillas de email cubren una amplia variedad de temas de negocios. Selecciona la plantilla que quieres y expórtala directamente a tu email, donde podrás editarla.",
    feature_newsFeed_desc:
      "¡Te damos la bienvenida a nuestra revolucionaria experiencia de actualidad mundial! Aprende inglés gracias al contenido y las preguntas generadas de manera automática por el sistema de Learnship.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "Nuestro catálogo de artículos combina una biblioteca de contenido específico de cada industria con ejercicios generados por Inteligencia Artificial. Elige un artículo y un tema de gramática que te interese practicar.",
    feature_accentsAndDialects_desc:
      "Descubre cómo suena el inglés alrededor del mundo con nuestra biblioteca de muestras de habla regional",
    feature_stressAndIntonation_desc:
      "Haz que tu inglés suene más natural y sea fácil de entender aprendiendo a utilizar la acentuación, ritmo y entonación correctos cuando hablas.",
    feature_soundOfEnglish_desc:
      "Mejora tus habilidades comunicativas aprendiendo a pronunciar los sonidos del inglés correctamente.",
    feature_vocabularyCenter_desc:
      "Sin gramática, puedes transmitir poco. Sin vocabulario, no podrás transmitir nada. - David Wilkins",
    feature_grammarCenter_desc:
      "El Centro de Gramática te ayudará a emplear la gramática correcta en tu expresión oral y escrita. Incluye temas de gramática, como las partes esenciales de la oración, verbos y formas verbales y oraciones y locuciones.",
    feature_globalCommunityTutorials_desc:
      "Mejora tus habilidades de inglés con esta colección de lecciones desarrolladas por la comunidad.",
    feature_toeic_desc:
      "El examen TOEIC® es una de las herramientas más usadas en empresas multinacionales para determinar el nivel de inglés de sus empleados. TOEIC® emplea material escrito y diálogos auténticos para determinar las habilidades de inglés de negocios.",
    feature_toefl_desc:
      "TOEFL®, Test of English as a Foreign Language (test de inglés como lengua extranjera), se emplea en universidades, agencias gubernamentales y programas de becas de todo el mundo para evaluar el nivel de inglés.",
    feature_businessSituations_desc:
      "El 'índice de situaciones empresariales' te ayuda a encontrar actividades específicas de manera que puedas centrarte en el idioma y expresarte en una variedad de situaciones de negocios.",
    //carousel block translations
    title_feature: "Características",
    we_recommend: "También recomendamos",
    // session report translations
    SessionReport_sessionReport: "Informe de la sesión",
    SessionReport_sessionDetails: "Detalles",
    SessionReport_teacherName: "Nombre del profesor",
    SessionReport_sessionReview: "Evaluación de la sesión",
    SessionReport_sessionFeedback: "Feedback de la sesión",
    SessionReport_sessionMaterials_Assignments: "Materiales de la sesión y tareas",
    SessionReport_instructions: "Instrucciones",
    SessionReport_open: "Abrir",
    SessionReport_invalidSession_Message: "Lo sentimos, esta sesión no contiene ningún informe.",
    SessionReport_rateSession: "Puntúa tu sesión",
    SessionReport_coachName: "¿Cómo fue tu sesión con",
    SessionRating_sessionDate: "Fecha de la sesión",
    SessionRating_sessionTime: "Tiempo de la sesión",
    SessionRating_sessionDuration: "Duración de la sesión",
    SessionRating_status: "Estado",
    SessionRating_rateYourExperience: "Puntúa tu experiencia",
    SessionRating_whatWentWrong: "¿Qué salió mal?",
    SessionRating_content: "Contenido",
    SessionRating_technology: "Tecnología",
    SessionRating_comment: "Deje un comentario",
    SessionRating_submit: "Enviar",
    SessionRating_remindMeLater: "Recordarme más tarde",
    SessionRating_close: "Cerrar",
    SessionRating_completed: "Completadas",
    sessionRating_sessionDetails_mins: "Minutos",

    // my schedule page translations
    myschedule_availability_abty_given: "Estamos trabajando para encontrar el mejor profesor para ti.",
    myschedule_schedule: "Mi calendario",
    myschedule_availability_needAvl: "Necesitamos tu disponibilidad para programar su sesión",
    myschedule_availability_abty_not_given: "Indica / Modifica tu disponibilidad",
    myschedule_statusCard_completed: "Sesiones completadas",
    myschedule_statusCard_remaining: "Sesiones restantes",
    myschedule_statusCard_scheduled: "Sesiones por programar",
    myschedule_statusCard_lost: "Sesiones perdidas (cancelaciones tardías y ausencias)",
    myschedule_recentUpcoming_courseName: "Nombre del curso",
    myschedule_next_session: "Próxima sesión",
    myschedule_session_topic: "Tema de la sesión",
    myschedule_sessionDetails_communication: "Comunicación",
    myschedule_sessionDetails_allSessions: "Todas las sesiones",
    myschedule_sessionDetails_upcomingSessions: "Próximas sesiones",
    myschedule_sessionDetails_pastSessions: "Sesiones anteriores",
    myschedule_sessionDetails_teacher_name: "Profesor",
    myschedule_sessionDetails_sessions: "Cantidad",
    myschedule_sessionDetails_date: "Fecha",
    myschedule_sessionDetails_time: "Tiempo",
    myschedule_sessionDetails_durationText: "Duración",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Cómo reprogramar una sesión",
    myschedule_reschedule_InstrBegin: "Cómo reprogramar sesiones con tu profesor",
    myschedule_reschedule_instr1a: "Ver detalles de la sesión en la parte superior",
    myschedule_reschedule_instr1b: "La fecha y hora de cada sesión se muestran en la parte superior de la pantalla.",
    myschedule_reschedule_instr2: "La disponibilidad del profesor aparecede marcada en verde",
    myschedule_reschedule_instr3:
      "Podrás ver la disponibilidad de tu profeosr. Las horas disponibles aparecen en verde.",
    myschedule_reschedule_instr4: "Selecciona un espacio para reprogramar tu sesión",
    myschedule_reschedule_instr5:
      "Para reprogramar una sesión, haz clic en el área verde de los espacios de horario disponibles",
    myschedule_reschedule_next_instr1: "Ningún horario adecuado",
    myschedule_reschedule_next_instr2:
      "Intenta evitar las cancelaciones, si no encuentras una hora adecuada con tu profesor, pulsa el botón 'NINGÚN HORARIO ADECUADO' para cancelar tu sesión. En este caso, tu profesor programará la sesión por ti o un administrador te ayudará.",
    myschedule_reschedule_next_instr3: "Cambiar de profesor",
    myschedule_reschedule_next_instr4a: "Para cambiar de profesor para una o más sesiones, utiliza nuestro",
    myschedule_reschedule_next_instr4b: "Formulario de Contacto,",
    myschedule_reschedule_next_instr4c:
      "y selecciona '<ProductName>' + 'Cambiar Profesor'. Indica el motivo por el que te gustaría cambiar de profesor.",
    myschedule_rechedule_next_info: "Para más información sobre la cancelación y el cambio de sesiones, visita nuestro",
    myschedule_rechedule_next_faq: "portal de FAQ",
    myschedule_rechedule_next_noShow: "No volver a mostrar esta página",
    myschedule_rechedule_next_done: "Hecho",
    myschedule_rechedule_skipButton: "Saltar",
    myschedule_upcoming_joinNow: "Participar ahora",
    myschedule_cancel_question: "¿Estás seguro que quieres cancelar la sesión?",
    myschedule_cancel_button: "Cancelar sesión",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "Lo sentimos, esta sesión no es válida",
    myschedule_sessionDuraion_minutes: "Minutos",
    myschedule_homepage_view: "Ver",
    myschedule_finished_status: "Completadas",
    myschedule_reschedule_button: "Reprogramar",
    myschedule_addToCalendar_instr1: "Pulsa en el",
    myschedule_addToCalendar_instr2:
      "botón de descarga para obtener tu horario con Learnship. Así podrás incorporarlo a tu calendario personal.",
    myschedule_addToCalendar_instr3:
      "Si has añadido un horario de Learnship con anterioridad, asegúrate de eliminarlo.",
    myschedule_addToCalendar_instr4: "Saber más sobre cómo incorporar tu horario de Learnship a tu calendario personal",
    myschedule_addToCalendar_instr5: "aquí",
    myschedule_no_teacher_title: "No tienes un profesor asignado",
    myschedule_no_teacher_body:
      "No se pueden añadir sesiones en este momento (No hay profesores asignados). Por favor, contacta con coach@globalenglish.com para continuar con tu programa.",
    myschedule_no_sessions: "No se encontró ninguna sesión",
    myschedule_no_upcoming_sessions: "No se encontraron próximas sesiones",
    myschedule_no_past_sessions: "No se encontraron sesiones anteriores",
    myschedule_status_lost: "Perdidas",
    myschedule_status_finished: "Completadas",
    myschedule_status_completed: "Completados",
    myschedule_status_cancelled: "Canceladas",
    myschedule_status_inprogress: "En curso",
    myschedule_status_pending: "Pendientes",
    myschedule_status_active: "Activas",
    myschedule_status_inplanning: "Planificadas",

    // my schedule page translations end

    // Progress page
    progress_title: "Mi progreso",
    progress_activity_report: "Informe de actividad",
    progress_test_results: "Resultados de la prueba",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Habilidades de Reach",
    progress_skill_note:
      "Debe completar el 70%  o más de su curso y las sesiones para conseguir un certificado de finalización.",
    progress_overall_card_title_prework: "Trabajo previo completado",
    progress_overall_card_title_homework: "Tarea completada",
    progress_overall_card_title_session: "Sesiones completadas",
    progress_overall_card_title_certificate: "Certificado",
    progress_overall_card_title_skillsCompleted: "Habilidades completadas",
    progress_overall_card_title_badgesEarned: "Medallas ganadas",
    progress_overall_card_title_missionsPassed: "Misiones aprobadas",
    progress_overall_card_title_timeInReach: "Tiempo en Reach (HH:MM)",
    progress_noSubskill: "No hay ninguna subhabilidad para mostrar.",
    progress_tab_nodata: "No hay datos para mostrar.",
    progress_percentCompleted: " % completado",
    progress_subskill_preworkTitle: "Trabajo previo",
    progress_subskill_homeworkTitle: "Tareas",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Completados",
    progress_subskill_sessionStatusNotCompleted: "No completadas",
    progress_subskill_sessionStatusNoSessions: "No hay sesiones",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Tiempo total",
    progress_activity_tooltip_activitiesCompleted: "Actividades completadas",
    progress_activity_tooltip_reachMissionsCompleted: "Misiones de Reach completadas",
    progress_activity_tooltip_timeinhhmm: "Hora en HH:MM",
    progress_activity_tabDaily: "Diario",
    progress_activity_tabWeekly: "Semanal",
    progress_activity_tabMonthly: "Mensual",
    progress_activity_tabQuarterly: "Trimestral",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Anual",
    progress_acitivity_Minutes: "Minutos",
    progress_acitivity_legend_selfpaced: "Tiempo de aprendizaje autoguiado",
    progress_acitivity_legend_trainerLed: "Tiempo con profesor",
    progress_acitivity_legend_recommended: "Recomendado",
    progress_testresults_table_testname: "Nombre del test",
    progress_testresults_table_scores: "Puntuaciones",
    progress_testresults_table_date: "Fecha",
    progress_testresults_info: "Los resultados del examen estarán disponibles en 24 horas.",
    progress_inprogress: "En curso",
    progress_totalscore: "Calificación total",
    progress_placedText: "Resultado",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Parte",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "Para conseguir un certificado de finalización, tendrás que completar el 70 % de los ejercicios digitales.",
    progress_badge_dialog_box_golden: "Con una calificación del 80 %, obtendrás una insignia de oro",
    progress_badge_dialog_box_silver: "Con una calificación entre el 70 % y el 79 %, obtendrás una insignia de plata",
    progress_badge_dialog_box_bronze: "Con una calificación entre el 50 % y el 69 %, obtendrás una insignia de bronce",
    progerss_badge_dailog_box_digitalActivities:
      "La calificación total se calcula en función de tu rendimiento y participación en las actividades digitales",
    progress_badge_dailog_box_liveSessions:
      "La calificación total se calcula en función de tu rendimiento y participación en las sesiones en vivo y las actividades digitales",

    //EO Progress page
    //Email templates
    wcGroup1: "Disculpas",
    wcGroup2: "Reclamos",
    wcGroup3: "Cumplidos",
    wcGroup4: "Felicitaciones",
    wcGroup5: "Documentos",
    wcGroup6: "Invitaciones",
    wcGroup7: "Solicitudes de empleo",
    wcGroup8: "Mercadeo y ventas",
    wcGroup9: "Reuniones",
    wcGroup10: "Avisos",
    wcGroup11: "Pedidos",
    wcGroup12: "Información de precios",
    wcGroup13: "Solicitudes",
    wcGroup14: "Gracias",
    wcTitle11: "Disculpas por un retraso en un proyecto",
    wcTitle12: "Disculpas por un error de contaduría",
    wcTitle13: "Disculpas por un envío tardío",
    wcTitle14: "Disculpas por entrega de bienes dañados",
    wcTitle15: "Disculpas por faltar a una reunión",
    wcTitle21: "Reclamo general",
    wcTitle22: "Reclamo sobre un problema con un producto",
    wcTitle23: "Reclamo sobre un sobrecargo a una cuenta",
    wcTitle31: "Cumplido a un colega sobre un proyecto",
    wcTitle32: "Cumplido sobre servicio al cliente",
    wcTitle33: "Cumplido sobre un producto",
    wcTitle41: "Felicitaciones por un ascenso (formal)",
    wcTitle42: "Felicitaciones por un ascenso (informal)",
    wcTitle43: "Felicitaciones por un evento personal",
    wcTitle51: "Documento solicitado",
    wcTitle52: "Formulario de pedido u orden de compra",
    wcTitle53: "Factura",
    wcTitle61: "Invitación a un evento social",
    wcTitle62: "Invitación a un evento empresarial",
    wcTitle63: "Cómo aceptar una invitación",
    wcTitle64: "Cómo rechazar una invitación",
    wcTitle65: "Cómo cancelar un evento empresarial",
    wcTitle71: "Acuse de recibo de una solicitud",
    wcTitle81: "Anuncio de un producto nuevo ",
    wcTitle82: "Anuncio de un representante de área nuevo",
    wcTitle83: "Demostración de un producto nuevo",
    wcTitle84: "Cambio de dirección de facturación",
    wcTitle85: "Contacto después de una primera reunión de ventas",
    wcTitle86: "Bienvenida a un cliente nuevo ",
    wcTitle87: "Mensaje de festivo a accionistas o clientes",
    wcTitle91: "Cómo proponer una hora para una reunión",
    wcTitle92: "Cómo confirmar una reunión",
    wcTitle93: "Cómo posponer una reunión",
    wcTitle94: "Cómo cancelar una reunión",
    wcTitle95: "Cómo resumir una reunión",
    wcTitle101: "Cuenta suspendida",
    wcTitle102: "Solicitud para cerrar una cuenta",
    wcTitle111: "Cómo confirmar un pedido",
    wcTitle112: "Cómo entregar una confirmación de envío",
    wcTitle113: "Cómo cancelar un pedido",
    wcTitle114: "Cómo cambiar un pedido",
    wcTitle115: "Cómo acusar recibo de una entrega",
    wcTitle121: "Cómo proporcionar información de precios",
    wcTitle122: "Cómo aceptar una cotización de precios",
    wcTitle123: "Cómo rechazar una cotización de precios",
    wcTitle131: "Solicitud de clarificación de información",
    wcTitle132: "Solicitud de información sobre un producto",
    wcTitle133: "Solicitud de información sobre un servicio",
    wcTitle141: "Agradecimiento general",
    Blob:
      "Las plantillas de correo electrónico abarcan una amplia variedad de temas empresariales. Seleccione la plantilla que desee y expórtela directamente a su cliente de correo electrónico para editarla.",
    OpenInEmail: "Abrir en correo electrónico",
    Quote1: "Actualmente hay 3.300 millones de cuentas de correo electrónico en todo el mundo.",
    Quote1By: "Mashable",
    Quote2: "El correo electrónico duplica la tasa de retorno, en comparación con otros canales de comunicación.",
    Quote2By: "Director de marketing directo",
    Quote3: "Cada segundo se envían 3,5 millones de correos electrónicos.",
    Quote3By: "Director de marketing",
    SelectACategory: "Seleccione una categoría",
    Title: "Plantillas de correo electrónico",
    WatchTutorial: "Vea un tutorial en video",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Norteamérica",
    Cenam: "Centroamérica",
    SoAm: "Sudamérica",
    EUR: "Europa",
    ASIA: "Asia",
    CenASIA: "Asia Central",
    SoEASIA: "Sudeste Asiático",
    MidEAST: "Oriente Medio",
    AFR: "África",
    AUST: "Australia",
    Cana: "Canadá",
    Mexi: "México",
    Uniteds: "Estados Unidos",
    CostaR: "Costa Rica",
    DomRep: "República Dominicana",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panamá",
    TriniTob: "Trinidad y Tobago",
    Arge: "Argentina",
    Braz: "Brasil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Perú",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Bélgica",
    Bulg: "Bulgaria",
    Croatia: "Croacia",
    Czec: "República Checa",
    Denm: "Dinamarca",
    Finl: "Finlandia",
    Fran: "Francia",
    Germ: "Alemania",
    Greec: "Grecia",
    Hung: "Hungría",
    Icel: "Islandia",
    Irel: "Ireland",
    Ital: "Italia",
    Lith: "Lituania",
    Luxem: "Luxemburgo",
    Neth: "Países Bajos",
    Norw: "Noruega",
    Pola: "Polonia",
    Port: "Portugal",
    Roma: "Rumanía",
    Russ: "Rusia",
    Serb: "Serbia",
    Slovakia: "Eslovaquia",
    Slovania: "Eslovenia",
    Spai: "España",
    Swed: "Suecia",
    Swit: "Suiza",
    Turk: "Turquía",
    Ukra: "Ucrania",
    Unitedk: "Reino Unido",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "India",
    Japa: "Japón",
    Mongo: "Mongolia",
    Pakis: "Paquistán",
    SoKore: "Corea del Sur",
    SriLan: "Sri Lanka",
    Taiw: "Taiwán",
    Afgh: "Afganistán",
    Azer: "Azerbaiyán",
    Kaza: "Kazajistán",
    Camb: "Camboya",
    Indo: "Indonesia",
    Malay: "Malasia",
    Phil: "Filipinas",
    Sing: "Singapur",
    Thai: "Tailandia",
    Viet: "Vietnam",
    Bah: "Baréin",
    Iran: "Irán",
    Iraq: "Iraq",
    Isra: "Israel",
    Jor: "Jordania",
    Kuw: "Kuwait",
    Leb: "Líbano",
    Oma: "Omán",
    Qat: "Qatar",
    SauArb: "Arabia Saudí",
    UAE: "Emiratos Árabes Unidos",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egipto",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenia",
    Malaw: "Malaui",
    Moroc: "Marruecos",
    Mozam: "Mozambique",
    Nige: "Nigeria",
    SoAfr: "Sudáfrica",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "Nueva Zelanda",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Familiarízate con las culturas de las regiones relevantes para tu empresa y vida profesional.",
    culturenotes_useculturalinfo:
      "Consulta la información cultural que ofrecemos para preparar reuniones con clientes y compañeros de distintos países.",
    culturenotes_topicfamiliarize:
      "Familiarízate con las costumbres de otras culturas, como horarios laborales, cenas fuera de casa, regalos, entre otras.",
    culturenotes_topiclearnculture:
      "Aprende sobre otras prácticas y diferencias culturales, así como las formas correctas de comportarse en cada lugar, para evitar cometer errores culturales.",
    culturenotes_tmaworldtext:
      "Los informes sobre cada país son elaborados por nuestro socio TMA World , y están disponibles en versiones PDF para descargar.",
    culturenoteslocation_viewbytopic: "Ver por tema",
    culturenoteslocation_viewbycountry: "Ver por país",
    dailyNewsFeed_resources: "Recursos",
    dailyNewsFeed_daily_News: "News Feed diario",
    dailyNewsFeed_newsfeedoftheday: "News Feed del día",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Lo sentimos, no podemos mostrar News Feed, vuelve a intentarlo más tarde",
    dailyNewsFeed_viewMoreCategories: "Ver más",
    // Email templates end
    //Error Page Translations
    error_not_found: "¡Vaya! no se encuentra la página.",
    error_contact_csm: "Pide ayuda a tu customer success manager.",
    error_under: "Bajar",
    error_maintenance: "Mantenimiento",
    error_under_maintenance: "La página está actualmente en mantenimiento programado.",
    error_inconvenience: "Lamentamos las molestias.",
    error_tryagain: "Vuelve a intentarlo más tarde.",
    error_tryagainMins: "Vuelve a intentarlo en",
    error_minutes: "minuto(s)",
    error_hours: "hora(s)",
    error_oops: "¡Vaya!",
    error_permission_denied: "No tienes permiso para ver esta página.",
    error_link_home: "página de inicio",
    error_contact_admin: "Contacta con tu administrador de Learnship para pedir ayuda.",
    error_sorry: "Lo sentimos",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "Borra la caché de tu navegador, comprueba la conexión a Internet y vuelve a intentarlo.",
    error_contact: "Contacta con nuestro",
    error_contact_cst: "equipo de Atención al Cliente",
    error_forhelp: "para obtener ayuda.",
    error_having_trouble: "¿Todavía tienes problemas?",
    //Accents and Dialects Dropdowns
    AF: "África",
    AS: "Asia",
    AU: "Australia y Oceanía",
    CA: "El Caribe",
    CE: "Centroamérica",
    EU: "Europa",
    MI: "Medio Oriente",
    NO: "Norteamérica",
    SO: "Sudamérica",
    CAMER: "Camerún",
    EGYPT: "Egipto",
    ETHIO: "Etiopía",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Sudáfrica",
    TANZA: "Tanzania",
    AFGHA: "Afganistán",
    CHINA: "China",
    INDIA: "La India",
    INDON: "Indonesia",
    JAPAN: "Japón",
    KAZAK: "Kazajistán",
    LEBAN: "El Líbano",
    MONGO: "Mongolia",
    NORTH: "Vietnam del Norte",
    PAKIS: "Pakistán",
    PHILI: "Filipinas",
    SINGA: "Singapur",
    KOREA: "Corea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwán",
    THAIL: "Tailandia",
    TURKM: "Turkmenistán",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "Nueva Zelandia",
    BERMU: "Bermudas",
    CUBA_: "Cuba",
    HAITI: "Haití",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (francesa)",
    TRINI: "Trinidad y Tobago",
    AUSTRI: "Austria",
    BELAR: "Bielorrusia",
    BELGI: "Bélgica",
    BULGA: "Bulgaria",
    CYPRU: "Chipre",
    CZECH: "República Checa",
    DENMA: "Dinamarca",
    ENGLA: "Inglaterra",
    FINLA: "Finlandia",
    FRANC: "Francia",
    GEORG: "Georgia",
    GERMA: "Alemania",
    GREEC: "Grecia",
    HUNGA: "Hungría",
    IRELA: "Irlanda",
    ITALY: "Italia",
    MACED: "Macedonia del Norte",
    NETHE: "Países Bajos",
    NORTHI: "Irlanda del Norte",
    POLAN: "Polonia",
    ROMAN: "Rumanía",
    RUSSI: "Federación Rusa",
    SCOTL: "Escocia",
    SPAIN: "España",
    SWEDE: "Suecia",
    SWITZ: "Suiza",
    TURKE: "Turquía",
    UKRAI: "Ucrania",
    WALES: "Gales",
    IRAN_: "Irán",
    IRAQ_: "Irak",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Arabia Saudita",
    SYRIA: "Siria",
    CANAD: "Canadá",
    MEXIC: "México",
    ARGEN: "Argentina",
    BRAZI: "Brasil",
    CHILE: "Chile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Perú",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Acentos y dialectos ",
    US: "Estados Unidos de América",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "California",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawai",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Luisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "Nueva Jersey",
    NEW_Y: "Nueva York",
    NCARO: "Carolina del Norte",
    NDAKO: "Dakota del Norte",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pensilvania",
    SOUTH_US: "Carolina del Sur",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "Virginia Occidental",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Tu empresa ha solicitado un informe mensual sobre tu progreso en Learnship para tu manager. Indica la dirección de correo electrónico de tu manager.",
    // survey and notification
    notification_description_plural: "{days} days remaining to complete the survey. You must complete it by {date}.",
    notification_description_singular: "1 day remaining to complete the survey. You must complete it by {date}.",
    notification_maintenance_message: "Halo will be undergoing scheduled maintenance on {date} at {time}.",
    //renewal
    renewal_welcome: "Bienvenido otra vez a Learnship. ",
    renewal_text:
      "Su licencia de Learnship vencerá el día {date} de {month} de {year}. Si desea continuar mejorando sus conocimientos de inglés empresarial, no olvide renovar su licencia hoy mismo. Se guardarán todos sus progresos, así como su plan de estudios, para que pueda continuar por su nivel de conocimientos.",
    renewal_later: "Recordar más tarde",
    renewal_affirmative: "Deseo renovar mi licencia.",
    renewal_negative: "No deseo renovar mi licencia.",
    renewal_yes: "SÍ",
    renewal_no: "NO",
    courselevel: "Nivel del curso",
    currentunit: "Unidad actual",
    upcomingsession: "Próximas sesiones",
    viewschedule: "View Schedule",
    currentskills: "Habilidades",
    currentsubskills: "Sub-habilidades",

    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading: "Practice your conversation skills with a teacher and other learners in our online classroom!",
    twt_instructions: "Instructions",
    twt_faq: "FAQs",
    twt_select_sessions: "Select your sessions",
    twt_view_schedule_title: "View schedule and add to calendar",
    twt_next_week: "Next week",
    twt_previous_week: "Previous week",
    twt_add_to_calendar: "Add to calendar",
    twt_view_more: "View more",
    twt_topic: "Topic",
    twt_topic_unavailable: "Topic time not available",
    twt_class_policy_title: "Normas y directrices de Hable con el profesor",
    twt_class_policy_subHeading:
      "Las siguientes políticas y pautas son importantes para garantizar que su experiencia en Hable con el Profesor (TWT) sea educativa y agradable. Por favor léalas cuidadosamente.",
    twt_class_policy_list01:
      "Usted podrá ingresar a una sesión por semana*. Nuestro salón virtual tiene un límite de 8 estudiantes como máximo. Mejores prácticas: Llegue cerca al horario en que inicia la sesión. Los salones virtuales de TWT están listos para que entre solo durante los 10 primeros minutos de cada sesión. Por ejemplo, una sesión inicia a las 9:00, estará disponible para ingresar hasta las 9:10. Después de los primeros 10 minutos, usted ya no podrá unirse a la sesión. Limitado o sin límite de accesos dependen del tipo de licencia que usted tenga.",
    twt_class_policy_list02_sub1:
      "Cuando usted ingrese al salón, escriba su nombre, ciudad, país, y nivel en la caja de Chat.",
    twt_class_policy_list02_sub2: `Por ejemplo: "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "El instructor activará su micrófono y aparecerá el icono de micrófono.",
    twt_class_policy_list03:
      "Si usted tiene un problema técnico, por favor contacte a nuestro equipo de Soporté. Haga clic en Ayuda en la parte superior de cualquier página donde se encuentre dentro del servicio y envíe el problema que presenta escribiendo, o usted puede hablar con un representante del equipo de Soporte utilizando la herramienta de Chat localizada en la página de Learnship One. Por favor no le pida al profesor del salón virtual por ayuda técnica.",
    twt_class_policy_list04:
      "Hay 4 niveles para las sesiones de Hable con el Profesor (TWT): Principiantes, Intermedios, Avanzados y Todos los niveles. Usted debe ir a la sesión que apropiada para sus habilidades en el inglés. Por ejemplo, si usted está en alguno de los niveles 0-3, requiere ir a una sesión de Principiantes. Cualquier estudiante (en cualquier nivel) puede atender las sesiones de Todos los niveles. Si usted logra unirse a una sesión de TWT que no es la más apropiada para sus habilidades en el inglés, su instructor le informara que usted no está en la sesión correcta. Usted tendrá dos opciones: Puede decirle a su instructor que quiere quedarse y quedarse a solo escuchar, por ejemplo, usted no podrá participar (hablar); o usted puede dejar la sesión y unirse más tarde a otra sesión en su nivel correcto.",
    twt_class_policy_list05:
      "Si usted desea escuchar en una sesión en línea sin querer hablar, lo puede hacer, una hora a la semana. Después de eso, usted ya podrá participar hablando durante la sesión. Usted podrá escuchar sin hablar un total de 4 sesiones al año. Si rebase ese límite, y no quiere participar (hablando) durante la sesión, se terminará dicha sesión.",
    twt_class_policy_list06:
      "No toleraremos un lenguaje obsceno u ofensivo en inglés o en cualquier otro idioma. Si infringe esta política, lo retiraremos inmediatamente de la sesión. Notificaremos a su gerente sobre este comportamiento ofensivo y podríamos cancelar su cuenta.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
  },
};
